import React, { useEffect, useState } from 'react';
import HomepageButton from './buttons/Homepage';
import AllVodButton from './buttons/AllVod';
import LikeButton from './buttons/Like';
import ShareButton from './buttons/Share';
import TranslateButton from './buttons/Translate';
import ChattingButton from './buttons/Chatting';

import * as MODE from '../../../common/constants/live/mode';
import * as SHARE from '../../../common/constants/live/share';

export default function InfoWrapper(props) {
  const [isMSIE, setIsMSIE] = useState(true);

  useEffect(() => {
    const ua = window.navigator.userAgent;
    setIsMSIE(ua.indexOf('MSIE') > -1 ? true : false);
  }, []);

  const onClickLikeButton = () => {
    props.onClickLikeButton();
  };
  const onClickShareButton = (platform, event) => {
    const shareTitle = encodeURIComponent(props.data.title);
    const shareUrl = encodeURIComponent(window.location.href);
    if (platform === 'facebook') {
      window.open(
        `${SHARE.URL_FACEBOOK}?t=${shareTitle}&u=${shareUrl}`,
        '',
        ''
      );
    } else if (platform === 'twitter') {
      window.open(
        `${SHARE.URL_TWITTER}?text=${shareTitle}&url=${shareUrl}`,
        '',
        ''
      );
    } else if (platform === 'kakaostory') {
      window.open(
        `${SHARE.URL_KAKAOSTORY}?content=${shareTitle}&url=${shareUrl}`,
        '',
        ''
      );
    } else if (platform === 'clipboard') {
      let tempTextArea = document.createElement('textarea');
      tempTextArea.value = window.location.href;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      tempTextArea.setSelectionRange(0, 9999);
      document.execCommand('copy');
      document.body.removeChild(tempTextArea);
      alert(`${window.location.href} 가 클립보드에 복사 되었습니다.`);
      if (event?.currentTarget.id)
        document.getElementById(event.currentTarget.id).focus();
    }
  };
  const onClickTranslateButton = () => {
    props.onChangeMode(MODE.LIVE_MODE_TRANSLATE);
  };
  const onClickChattingButton = () => {
    props.onChangeMode(MODE.LIVE_MODE_CHATTING);
  };

  const onChangeFocus = () => {
    props.onChangeFocus(null);
  };

  const onClickKeyboardGuide = () => {
    const guideLayer = document.querySelector('.keyboardGuideLayer');
    if (guideLayer) {
      guideLayer.style.display = guideLayer.style.display === 'none' ? 'block' : 'none';
    }
  };

  return (
    <div className="live_info_w">
      <div
        className="live_info_inner"
        tabIndex="0"
      >
        <h2 className="live_info_channel">{props.data.channelname}</h2>
        <div className="live_info_title">{props.data.title}</div>
        <div className="live_subinfo_w">
          <div className="live_subinfo_time">
            방송시간
            <span className="lsi_time_number">{`${props.data.time}`}</span>
          </div>
          <div className="mb_label_w live_subinfo_guest">
            {(props.data.channelid === 'S17' ||
              props.data.channelid === 'S18') && (
              <span className="mb_label_bora" title="보는라디오">
                보라
              </span>
            )}
            {props.data.guest_name && (
              <span className="lsi_guest_name">{props.data.guest_name}</span>
            )}
          </div>
        </div>

        <div className="keyboardGuide_w">
          <button 
            className="btn_keyboardGide_open" 
            type="button" 
            title="키보드 컨트롤 안내 열기"
            onClick={onClickKeyboardGuide}
          >
            키보드 컨트롤 안내
          </button>
          <div id="keyboard_guide" className="keyboardGuideLayer" style={{display: 'none'}}>
            <em className="keyboardGuide_title">플레이어 키보드 단축키 안내</em>
            <ul className="keyboardGuideList">
              <li className="keyboardGuideList_inner">
                <strong className="keyboardGuideList_title">재생/정지</strong>
                <div className="keyboardGuideList_btn type_play"><span className="icon_play"></span></div>
              </li>
              <li className="keyboardGuideList_inner">
                <strong className="keyboardGuideList_title">영상 10초 앞으로</strong>
                <div className="keyboardGuideList_btn type_prev"><span className="icon_prev"></span></div>
              </li>
              <li className="keyboardGuideList_inner">
                <strong className="keyboardGuideList_title">영상 10초 뒤로</strong>
                <div className="keyboardGuideList_btn type_next"><span className="icon_next"></span></div>
              </li>
              <li className="keyboardGuideList_inner">
                <strong className="keyboardGuideList_title">음소거/음소거 해제</strong>
                <div className="keyboardGuideList_btn type_volume"><span className="icon_volume"></span></div>
              </li>
            </ul>
            <button 
              className="btn_keyboardGide_closed" 
              type="button" 
              title="키보드 컨트롤 안내 닫기" 
              onClick={onClickKeyboardGuide}>
              <i className="ir">닫기</i>
            </button>
          </div>
        </div>

      </div>
      <div className="live_btns_w">
        <HomepageButton {...props.data} />
        <AllVodButton {...props.data} />
        <LikeButton {...props.data} onClick={onClickLikeButton} />
        <ShareButton {...props.data} onClick={onClickShareButton} />
        {!isMSIE &&
          (props.data.programid === '' || props.data.programid &&
            props.data.programid.indexOf('P451172214') === -1) && (
            <TranslateButton
              {...props.data}
              focus={props.focusname === 'translate'}
              onChangeFocus={onChangeFocus}
              onClick={onClickTranslateButton}
            />
          )}
        {!isMSIE && (
          <ChattingButton
            {...props.data}
            focus={props.focusname === 'chatting'}
            onChangeFocus={onChangeFocus}
            onClick={onClickChattingButton}
          />
        )}
      </div>
    </div>
  );
}
